import { Prisma } from '@prisma/client'
import { axios } from '@repo/shared-core-utilities-http-clients/axios'
import type { UserPreferencesWebAPI } from '@repo/shared-types/web-api/user-preferences'
import { keepPreviousData } from '@tanstack/react-query'
import { createMutation, createQuery } from 'react-query-kit'

// --------------------------------------------------------------------------------------------- //

type GetUserPreferencesVariables = void

export const useGetUserPreferences = createQuery<UserPreferencesWebAPI, GetUserPreferencesVariables, Error>({
  placeholderData: keepPreviousData,
  queryKey: ['user-preferences'],
  fetcher: async (variables, { queryKey: [primaryKey], signal, meta }) => {
    const queryString = `/api/${primaryKey}`

    const results = await axios.get(queryString, { signal })

    return results.data
  }
})

// --------------------------------------------------------------------------------------------- //

interface UpdateUserPreferencesVariables {
  data: Prisma.UserPreferencesUpdateArgs['data']
}

export const useUpdateUserPreferences = createMutation<void, UpdateUserPreferencesVariables, Error>({
  mutationFn: async (params: UpdateUserPreferencesVariables) => {
    const { data } = await axios.put(`api/user-preferences`, { ...params.data })
    return data
  },
  mutationKey: ['user-preferences']
})

// --------------------------------------------------------------------------------------------- //
